export const environment = {
  production: true,
  api_url: 'https://portal-api.aumentcoin.com/v1',
  api_key: 'YXVtZW50LWNsaWVudDphdW1lbnQtY2xpZW50LXNlY3JldA==',
  storage_coins: 'https://aumentstorage.blob.core.windows.net/coins/',
  captcha_site_key: '6Lc_JpopAAAAAONj13P96F7FGxA787ShBe2ZL00r',
  showConstructionPopup: true
};
